// "Next" affordance for horizontal scroll tracks: advances one snap step and
// hides itself when the track can't scroll further (or at all).
export function initScrollNext() {
  const buttons = document.querySelectorAll('[data-scroll-next]');

  buttons.forEach((button) => {
    const track = document.getElementById(button.getAttribute('aria-controls'));
    if (!track) return;

    const step = () => track.firstElementChild?.offsetWidth || track.clientWidth;

    const update = () => {
      const scrollable = track.scrollWidth > track.clientWidth;
      const done = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      button.classList.toggle('is-hidden', !scrollable || done);
    };

    button.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}
